import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from '@material-ui/styles';
import NavContainer from './Nav/NavContainer';

export function NavImplWithTheme({ theme, onNavItem }) {
  return (
    <div
      style={{
        width: '250px',
        height: '100vw',
        float: 'left',
        backgroundColor: theme.palette.primary.main,
        minHeight: '100vw',
      }}
    >
      <NavContainer onNavItem={onNavItem} />
    </div>
  );
}

const navProps = {
  theme: PropTypes.shape({
    palette: PropTypes.shape({
      primary: PropTypes.shape({
        main: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
  onNavItem: PropTypes.func.isRequired,
};

export { navProps };

NavImplWithTheme.propTypes = navProps;

const Nav = withTheme(NavImplWithTheme);
export default Nav;
